import React, {useState} from 'react';

import List from "components/List";
import ShippingMethodList from "./components/ShippingMethodList";
import FetchFromSyliusButton from "./components/FetchFromSyliusButton";
import {SyliusCandidatesContext} from "./context/SyliusCandidatesContext";

function ShippingMethods(props) {
    const [candidates, setCandidates] = useState([]);
    const [fetchReport, setFetchReport] = useState(null);
    const [prefill, setPrefill] = useState(null);

    return (
        <SyliusCandidatesContext.Provider value={{candidates, setCandidates, fetchReport, setFetchReport, prefill, setPrefill}}>
            <List
                title={'shippingMethods.title'}
                headerActions={<FetchFromSyliusButton />}
            >
                <ShippingMethodList />
            </List>
        </SyliusCandidatesContext.Provider>
    )
}

export default ShippingMethods;
